<div class="tr md-no-proxy layout-row layout-align-start-center">

  <!--Group Name-->
  <div class="td flex layout-row layout-align-start-center">
    <app-groups-color-display-list [groups]="[group]"></app-groups-color-display-list>
  </div>

  <!--External ID-->
  <div class="td flex layout-row layout-align-start-center">
    {{group.externalId || '--'}}
  </div>

  <!--Operational Units-->
  <div class="td flex layout-row layout-align-start-center">
    <branches-indicator [branches]="group.branchReferences"></branches-indicator>
  </div>

  <!--Tags-->
  <div class="td flex layout-row layout-align-start-center">
    <app-bringoz-tags *ngIf="group.tags?.length" [tags]="group.tags" maxTags="3"></app-bringoz-tags>
  </div>

  <!--Created At-->
  <div class="td flex layout-row layout-align-start-center">
    {{group | bringozFullDate: 'createdAt'}}
  </div>

  <!--Updated At-->
  <div class="td flex layout-row layout-align-start-center">
    {{group | bringozFullDate: 'updatedAt'}}
  </div>

  <!--Actions-->
  <div class="td flex-5 layout-row layout-align-start-center">
    <bringoz-button *ngIf="allowEdit"
                    type="tertiary"
                    (onClick)="editGroupEvent.emit(group)">
      <bringoz-icon iconName="edit-outline" classSize="lg" fill="#424242"></bringoz-icon>
    </bringoz-button>

    <bringoz-button *ngIf="allowDelete"
                    type="tertiary"
                    (onClick)="deleteGroupEvent.emit(group)">
      <bringoz-icon iconName="trash" classSize="lg" fill="#424242"></bringoz-icon>
    </bringoz-button>

  </div>
</div>
